"use client";
import GallerySlider from "@/components/GallerySlider/GallerySlider";
import { useGalleryContext } from "@/context/GalleryContext";
import { GalleryI, PhotoI } from "@/interfaces/galleries/Galleries";
import React from "react";

type GalleryContainer = {
  gallery: GalleryI;
  years: string[];
  photos: { [key: string]: PhotoI[] };
};
export const GalleryContainer = (props: GalleryContainer) => {
  const { gallery, years, photos } = props;
  const { activeXIndex, activeYIndex } = useGalleryContext();
  return (
    <>
      <GallerySlider gallery={gallery} years={years} photos={photos} />
      <div className="active-photo-description-container">
        {years.length && photos[years[activeXIndex]] && (
          <p className="font-light">
            {photos[years[activeXIndex]][activeYIndex]?.description}
          </p>
        )}
      </div>
    </>
  );
};
